const INITIAL_STATE = {
    locations: null,
    error: null,
    loading: false
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {

    case "FETCH_LOCATIONS":
        return { ...state, locations: null, error: null, loading: true, loaded: false };
    case "FETCH_LOCATIONS_SUCCESS":
        function childSelected (node) {
			if(node.nodes) {
            	for (var i = 0; i < node.nodes.length; i++) {
                	if (node.nodes[i].customerId) {return true}
                	if (node.nodes[i].nodes) { return childSelected(node.nodes[i])}
            	}
            }
            return false
        }
        function addSelectedChildField (node) {
            const newNode = Object.assign({}, node)
            newNode.childSelected = childSelected(newNode)
            if (newNode.nodes) { newNode.nodes = newNode.nodes.map(addSelectedChildField)}
            return newNode
        }

        return { ...state, locations: addSelectedChildField(action.payload), error:null, loading: false, loaded: true };
    case "FETCH_LOCATIONS_FAILURE":
        error = action.payload || {message: action.payload.message};
        return { ...state, locations: [], error: error, loading: false };

    default:
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/locations.js